import React, { useEffect, useState } from "react";
import reportService from "../../../services/report.service";
import Loadding from "../../common/loadding";
import GroupCheck from "../../report/reportDoc3/groupCheck";

const GroupChack = (props: {
  schedule: number;
  course: number;
  type: string;
}) => {
  const { schedule, course, type } = props;
  const [doc3, setDoc3] = useState<any>([]);
  const [status, setStatus] = useState(true);
  useEffect(() => {
    (async () => {
      // ไปเช็คที่ตาราง doc3 ว่ามี sche / course นี้ยัง
      await reportService.checkSend(schedule, course).then((res) => {
        // console.log(res.data);

        setDoc3(res.data);
        setStatus(false);
      });
    })();
  }, [course, schedule]);

  if (status) {
    return <Loadding />;
  }

  return (
    <>
      {doc3.doc5.split(",").map((x: string) => {
        return (
          <GroupCheck key={x} group={x} doc3Id={doc3.id} type={`${type}`} />
        );
      })}
    </>
  );
};

export default GroupChack;
